import React, { createContext, useState } from 'react';

const IdentityContext = createContext({});
const IdentityDispatchContext = createContext({});

const IdentityProvider = ({children}) => {
  const [authState, setAuthState] = useState(null);
  const [modules, setModules] = useState([]);
  const [initialUser, setInitialUser] = useState(null);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  const clearIdentityContext = () => {
    setUser(null);
    setRole(null);
    setModules([]);
    setInitialUser(null);
    setAuthState(null);   
  }

  return (
    <IdentityContext.Provider value={{authState, user, initialUser, modules, role}}>
      <IdentityDispatchContext.Provider value={{setAuthState, setUser, setInitialUser, setModules, setRole, clearIdentityContext}}>
        {children}
      </IdentityDispatchContext.Provider>
    </IdentityContext.Provider>
  );
}

export { IdentityProvider, IdentityContext, IdentityDispatchContext}




